import { render, staticRenderFns } from "./Setup1.vue?vue&type=template&id=d166b672&"
import script from "./Setup1.vue?vue&type=script&lang=js&"
export * from "./Setup1.vue?vue&type=script&lang=js&"
import style0 from "./Setup1.vue?vue&type=style&index=0&id=d166b672&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Setup1.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(component)

export default component.exports